export default __webpack_public_path__ + "static/online-custom-receipts-256b45c3c2f535d20e5571111ce7a1ef.png";